export default {
  // Hero Section
  'hero.badge': 'Become Part of the Digital Sports Revolution',
  'hero.title': 'SuperOne Leader & Affiliate Partner',
  'hero.subtitle': 'Start Internationally as One of the First',
  'hero.intro1': 'Digital Sports is our platform for innovative projects in the digital sports sector.',
  'hero.intro2': 'The central company we are talking about here is SuperOne – a global pioneer in digital fan engagement.',
  'hero.leaderDeal.title': 'Exclusive for Leaders',
  'hero.leaderDeal.desc1': 'Are you an experienced leader looking for an exceptional deal?',
  'hero.leaderDeal.desc2': 'Under certain conditions, we offer individual agreements for top leaders with proven experience and a strong network. Let\'s talk about your opportunities!',
  'hero.leaderDeal.feature1': 'Individual Terms',
  'hero.leaderDeal.feature2': 'Exclusive Territories',
  'hero.leaderDeal.feature3': 'Direct CEO Contact',
  'hero.note': '👉 This page is specifically about the opportunity to start internationally as a Leader or Affiliate Partner for SuperOne.',
  'hero.button': 'Apply Now',
  
  // Digital Sports x SuperOne
  'digitalSports.title': 'Digital Sports x SuperOne',
  'digitalSports.desc1': 'Digital Sports connects sports, community and technological innovation.',
  'digitalSports.desc2': 'SuperOne is the company we support internationally in its growth.',
  'digitalSports.looking': 'We are looking for Leaders and Affiliate Partners',
  'digitalSports.lookingDesc': 'who build their markets first and actively accompany SuperOne\'s expansion.',
  
  // Video Section
  'video.badge': 'Video Presentation',
  'video.title': 'The Vision of SuperOne by CEO',
  'video.ceo': 'Andreas Christensen',
  'video.subtitle': 'presented',
  'video.note': 'The video starts automatically muted. You can activate the sound at any time.',
  
  // Your Chance
  'chance.title': 'Your Chance:',
  'chance.titleHighlight': 'One of the First',
  'chance.titleSuffix': 'in Your Country',
  'chance.feature1.title': 'First Official Partners',
  'chance.feature1.desc': 'Be among the very first official partners in your country',
  'chance.feature2.title': 'Build Your Own Team',
  'chance.feature2.desc': 'Build and lead your own team or network',
  'chance.feature3.title': 'Global Expansion',
  'chance.feature3.desc': 'Benefit from global expansion in the long term',
  'chance.note': 'Especially leaders can build structures early in their region before the mass market is reached.',
  
  // 100% Serious
  'serious.title': '100% Serious',
  'serious.subtitle': 'Real Company, Real Value Creation',
  'serious.feature1.title': 'Real Product',
  'serious.feature1.desc': 'Functioning gaming ecosystem',
  'serious.feature2.title': 'Clear Value Creation',
  'serious.feature2.desc': 'Real revenue & business model',
  'serious.feature3.title': 'CEO Updates',
  'serious.feature3.desc': 'Regular exchange',
  'serious.feature4.title': 'Verifiable',
  'serious.feature4.desc': 'Transparent company structure',
  'serious.conclusion': 'As a Leader or Affiliate Partner, you benefit from full access to information, meetings and strategic insights.',
  
  // Game Live
  'gameLive.badge': 'Now Live Available',
  'gameLive.title': 'SuperOne is',
  'gameLive.titleHighlight': 'live',
  'gameLive.titleSuffix': 'in App Store & Google Play',
  'gameLive.subtitle': 'The game is already available and millions of players worldwide can download it',
  'gameLive.principle': 'The Game Principle',
  'gameLive.quiz.title': 'Football Quiz',
  'gameLive.quiz.desc': 'An exciting football quiz game where players test their knowledge',
  'gameLive.battleRoyale.title': 'Battle Royale Format',
  'gameLive.battleRoyale.desc': 'Players compete in a Battle Royale – only the best win',
  'gameLive.prizes.title': 'Real Cash Prizes',
  'gameLive.prizes.desc': 'Players can win real cash prizes – no virtual currencies',
  'gameLive.prizePool': 'Daily & Weekly Winners',
  'gameLive.prizePoolDesc': 'Regular winning opportunities',
  'gameLive.businessModel': 'The Business Model – Real Value Creation',
  'gameLive.step1.title': '10 Games Free',
  'gameLive.step1.desc': 'Every player can play 10 games for free daily',
  'gameLive.step2.title': 'GamePass for $1',
  'gameLive.step2.desc': 'For just $1, players can play unlimited',
  'gameLive.step3.title': 'Real Revenue',
  'gameLive.step3.desc': 'Value creation through GamePass purchases, not through deposits',
  'gameLive.conclusion': 'SuperOne is based on real digital revenue – a sustainable and transparent business model',
  
  // Why Now
  'whyNow.badge': 'Perfect Timing',
  'whyNow.title': 'Why',
  'whyNow.titleHighlight': 'Now',
  'whyNow.subtitle': 'SuperOne is on the verge of a worldwide breakthrough',
  'whyNow.feature1.title': 'Major Rollout',
  'whyNow.feature1.desc': 'Worldwide rollout in the coming weeks',
  'whyNow.feature2.title': 'Media Presence',
  'whyNow.feature2.desc': 'Presence in media & social media',
  'whyNow.feature3.title': 'International Stars',
  'whyNow.feature3.desc': 'Stars with up to 250 million followers launching campaigns',
  'whyNow.conclusion': 'This creates an exceptional timing advantage for Leaders and Affiliate Partners.',
  
  // Compensation Model
  'compensation.title': 'The Compensation Model –',
  'compensation.titleHighlight': 'Clear and Attractive',
  'compensation.system': 'Unilevel Affiliate System',
  'compensation.level1': 'Direct Partners',
  'compensation.level1Desc': 'On Level 1',
  'compensation.levels': 'Levels 2–10',
  'compensation.levelsDesc': 'Depending on qualification',
  'compensation.note': 'Leaders benefit particularly strongly as they can build larger teams and lead strategically.',
  
  // Fan Calculator
  'calculator.badge': 'Income Potential',
  'calculator.title': 'Your',
  'calculator.titleHighlight': 'Income Potential',
  'calculator.titleSuffix': 'in 12 Months',
  'calculator.subtitle': 'Realistic calculations based on one Pro Fanpack for $500 (one-time)',
  'calculator.scenario1': 'Scenario 1: Virality of 2',
  'calculator.scenario2': 'Scenario 2: Virality of 2.5',
  'calculator.conservative': 'Conservative Scenario',
  'calculator.realistic': 'Realistic Scenario',
  'calculator.investment': 'One-time Investment',
  'calculator.investmentDesc': '1 Pro Fanpack for $500 (one-time)',
  'calculator.virality2': 'Virality of 2',
  'calculator.virality2Desc': 'Each player refers the game to 2 more people per month',
  'calculator.virality25': 'Virality of 2.5',
  'calculator.virality25Desc': 'Each player refers the game to 2.5 more people per month',
  'calculator.annualRewards': 'Annual Rewards',
  'calculator.activeFans': 'Active Fans',
  'calculator.monetizedFans': 'Monetized Fans',
  'calculator.afterMonths': 'after 12 months',
  'calculator.ofFans': '20% of fans',
  'calculator.currentBetter': 'Currently Even Better!',
  'calculator.currentBetterDesc1': 'The calculations are based on a virality of 2 to 2.5 (conservative to realistic).',
  'calculator.currentBetterDesc2': 'Currently, the average virality is 6! This means that actual earnings can be significantly higher.',
  'calculator.comparison': 'Scenario Comparison',
  'calculator.metric': 'Metric',
  'calculator.annualRewardsMetric': 'Annual Rewards',
  'calculator.activeFansMetric': 'Active Fans',
  'calculator.monetizedFansMetric': 'Monetized Fans',
  'calculator.probability': 'Probability',
  'calculator.veryConservative': 'Very conservative',
  'calculator.realisticProb': 'Realistic (50%)',
  'calculator.currentAverage': 'Current average',
  'calculator.exponentialGrowth': 'Exponential Growth',
  'calculator.exponentialGrowthDesc': 'Through virality, your network grows exponentially',
  'calculator.probability50': '50% Probability',
  'calculator.probability50Desc': 'Conservative calculation with realistic assumptions',
  'calculator.arpu': 'ARPU $100',
  'calculator.arpuDesc': 'Average revenue per monetized fan',
  'calculator.cta.title': 'Start Now as Leader or Affiliate Partner',
  'calculator.cta.desc': 'With just $500 one-time, you can build a passive income that grows exponentially',
  'calculator.cta.button': 'Apply Now',
  
  // USP 1
  'usp1.badge': 'USP #1',
  'usp1.title': 'Real-time Commissions in',
  'usp1.titleHighlight': 'Crypto',
  'usp1.feature1': 'Real-time',
  'usp1.feature1Desc': 'Instant payout',
  'usp1.feature2': 'Direct to Wallet',
  'usp1.feature2Desc': 'To your own wallet',
  'usp1.feature3': 'Transparent',
  'usp1.feature3Desc': 'Traceable & secure',
  'usp1.conclusion': 'Ideal for leaders and affiliates who value fast and transparent compensation.',
  
  // USP 2
  'usp2.badge': 'USP #2',
  'usp2.title': 'Buy Gamers &',
  'usp2.titleHighlight': 'Expand Network',
  'usp2.subtitle': 'SuperOne offers all partners a special growth tool',
  'usp2.step1': 'Buy Gamers',
  'usp2.step1Desc': 'Gamers can be actively purchased',
  'usp2.step2': 'Automatically Level 1',
  'usp2.step2Desc': 'They automatically land in level 1',
  'usp2.step3': 'Become Partners',
  'usp2.step3Desc': 'Gamers can later become partners',
  'usp2.conclusion.title': 'Leaders Benefit Greatly',
  'usp2.conclusion.desc': 'This model accelerates both team building and income',
  
  // Support
  'support.title': 'Support &',
  'support.titleHighlight': 'Collaboration',
  'support.subtitle': 'As a Leader or Affiliate Partner, you receive comprehensive support',
  'support.feature1': 'Individual Zoom Calls',
  'support.feature2': 'Team Building Strategies',
  'support.feature3': 'Weekly Town Halls',
  'support.feature4': 'Promotions & Incentives',
  'support.feature5': 'Offline Events',
  'support.feature6': 'Leader Deals',
  
  // Who is it for
  'whoFor.title': 'Who is',
  'whoFor.titleHighlight': 'SuperOne',
  'whoFor.titleSuffix': 'suitable for',
  'whoFor.feature1': 'Experienced leaders who want to build teams',
  'whoFor.feature2': 'Affiliate partners who want to scale internationally',
  'whoFor.feature3': 'People with networks in sports, online marketing or social media',
  'whoFor.feature4': 'Entrepreneurs, influencers, agents and community builders',
  'whoFor.feature5': 'Anyone who wants to get into a globally growing system early',
  
  // Application Form
  'form.title': 'Next',
  'form.titleHighlight': 'Steps',
  'form.subtitle': 'If you want to start as a Leader or Affiliate Partner',
  'form.step1': 'Fill out form',
  'form.step1Desc': 'Short application',
  'form.step2': 'Personal conversation',
  'form.step2Desc': 'Get to know & questions',
  'form.step3': 'Onboarding & Start',
  'form.step3Desc': 'Get started immediately',
  'form.thankYou': 'Thank you for your application!',
  'form.thankYouDesc': 'We have received your application and will contact you within 24 hours.',
  'form.checkSpam': 'Please also check your spam folder',
  'form.name': 'Full Name',
  'form.email': 'Email Address',
  'form.phone': 'Phone Number',
  'form.country': 'Country',
  'form.role': 'Desired Role',
  'form.roleSelect': 'Please select',
  'form.roleLeader': 'Leader',
  'form.roleAffiliate': 'Affiliate Partner',
  'form.roleBoth': 'Both possible',
  'form.experience': 'Network Marketing Experience',
  'form.experienceNone': 'No experience',
  'form.experienceLittle': 'Little experience (1-2 years)',
  'form.experienceMedium': 'Medium experience (3-5 years)',
  'form.experienceMuch': 'Much experience (5+ years)',
  'form.experiencePro': 'Professional / Top Leader',
  'form.socialMedia': 'Social Media Channels',
  'form.socialMediaDesc': 'Provide your social media channels with links and reach',
  'form.instagram': 'Instagram',
  'form.instagramPlaceholder': 'e.g. @username - 10,000 followers',
  'form.facebook': 'Facebook',
  'form.facebookPlaceholder': 'e.g. facebook.com/username - 5,000 friends',
  'form.tiktok': 'TikTok',
  'form.tiktokPlaceholder': 'e.g. @username - 50,000 followers',
  'form.youtube': 'YouTube',
  'form.youtubePlaceholder': 'e.g. youtube.com/@channel - 20,000 subscribers',
  'form.linkedin': 'LinkedIn',
  'form.linkedinPlaceholder': 'e.g. linkedin.com/in/username - 3,000 connections',
  'form.other': 'Other Channels',
  'form.otherPlaceholder': 'e.g. Twitter, Telegram, etc.',
  'form.startBudget': 'Start Budget',
  'form.startBudgetDesc': 'What is your planned start budget?',
  'form.budget500': '$500',
  'form.budget5000': '$5,000',
  'form.budget10000': '$10,000',
  'form.budgetMore': 'More than $10,000',
  'form.message': 'Why do you want to become a SuperOne Partner?',
  'form.messagePlaceholder': 'Tell us about your goals and motivation...',
  'form.whatHappens': 'What happens after the application?',
  'form.whatHappens1': 'We review your application within 24 hours',
  'form.whatHappens2': 'You receive an invitation to a personal conversation',
  'form.whatHappens3': 'If suitable: Immediate onboarding and start possible',
  'form.submit': 'Submit Application',
  'form.submitting': 'Submitting...',
};